export enum ValuationPriceTypes {
  WHOLESALE = 'wholesale',
  FINAL = 'final',
  RETAIL = 'retail',
}
